
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy-rates/[slug]",
      function () {
        return require("private-next-pages/energy-rates/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy-rates/[slug]"])
      });
    }
  